import { getDoubleDeepPPO } from "../../../functions/planDetails";
import { IFullPlanDetailPPO } from "../../../interfaces/api";

import DoctorsDrugsTilePlan from "./DoctorsDrugsTilePlan.component";
import PPODoubleDeepInfoBenefitInOut from "./PPODoubleDeepInfoBenefitInOut.component";
import { useZipRootLoaderData } from "../../../hooks/useZipRootLoaderData";

const PPOPCPSPECDataTableDetailDoctors = ({
  data,
}: {
  data: IFullPlanDetailPPO;
}) => {
  const { selectedYear } = useZipRootLoaderData();
  const pcp =
    selectedYear === 2024
      ? getDoubleDeepPPO(
          data,
          "Doctor visits",
          "Primary Care Physician Services"
        )
      : getDoubleDeepPPO(
          data,
          "Doctor visits",
          "Primary Care Physician Services"
        );
  const specialist =
    selectedYear === 2024
      ? getDoubleDeepPPO(data, "Doctor visits", "Physician Specialist Services")
      : getDoubleDeepPPO(
          data,
          "Doctor visits",
          "Physician Specialist Services"
        );
  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",
        textAlign: "left",
      }}
    >
      <PPODoubleDeepInfoBenefitInOut benefit={pcp} title="PCP Copay" />
      <PPODoubleDeepInfoBenefitInOut
        benefit={specialist}
        title="Specialist Copay"
      />

      <DoctorsDrugsTilePlan planData={data} />
    </div>
  );
};

export default PPOPCPSPECDataTableDetailDoctors;
